module.exports = __webpack_public_path__ + "img/coupon_tutorial_totolu01.73da6a1d.png";